import { BaseType, DataType } from 'ui/ArrayFieldBox';
import {IEnumerationItem} from '../../configuration/model/Enumeration';

export default interface IBankPolicy {
    policyID?: number,
    groupPolicyID?: number,
    contractNumber?: string,
    contractNumberManual?: string,
    contractNumberExternal?: string,
    contractNumberValidation?: string,
    productCode?: string,
    agencyCode?: string,
    productName?: string,
    productDescription?: string,

    policyStatus?: string,
    policyStatusDate?: Date,

    effectiveDate: Date,
    loanDate?: Date,
    expirationDate?: Date,
    policySetupDate?: Date,

    paymentFrequency?: string,
    paymentDuration?: number,

    reimbursementStartDate?: Date,
    reimbursementEndDate?: Date,
    reimbursementDuration?: number,
    reimbursementDateAuto?: boolean,

    accountNumber?: string,
    loanNumber?: string,

    civility?: string,
    maritalSituation?: string,
    defaultLanguage?: string,
    height?: number,
    weight?: number,

    adressLine1?: string,
    adressLine2?: string,
    adressLine3?: string,

    riskElementID: number,
    bankRiskElementID: number,
    firstName?: string,
    lastName?: string,
    personNameNIC?: string,
    birthDate?: Date,
    birthPlace?: string,
    personIndice?: string,
    
    portable1?: string,
    portable2?: string,
    email1?: string,
    email2?: string,
    professionalCategory?: string,
    profession?: string,

    isInsuredPayor?: boolean,

    payorCivility?: string,
    payorMaritalSituation?: string,
    payorDefaultLanguage?: string,

    payorHeight?: number,
    payorWeight?: number,

    payorAdressLine1?: string,
    payorAdressLine2?: string,
    payorAdressLine3?: string,

    payorID?: number,
    bankPayorID?: number,
    payorFirstName?: string,
    payorLastName?: string,
    payorPersonNameNIC?: string,
    payorBirthDate?: Date,
    payorBirthPlace?: string,
    
    payorPersonIndice?: string,
    
    payorPortable1?: string,
    payorPortable2?: string,
    payorEmail1?: string,
    payorEmail2?: string,
    payorProfessionalCategory?: string,
    payorProfession?: string,

    tarifInfos: ITarifInfo[],
    coverages: ICoverage[]    

    capital?: number,
    netPremium?: number,
    tax?: number,
    duePremium?: number,
    accessories?: number,
    accessoriesTax?: number,
    dueAmount?: number,

    duration?: number,
    durationUnit?: string,
    //roleItems: IBankRoleItem[]
  }

  
  export interface ITarifInfo {
    name: string, 
    text: string,
    enumerationCode: string, 

    type: BaseType,
    dataType: DataType,

    eltValue: any, 
    id: string,
    enumerationItems: IEnumerationItem[]
  }


  export interface ICoverage {
    coverageCode?: string,
    coverageName?: string,
    coverageEvaluationType?: string,

    capital: number,
    recCapital: number,
    basePremium: number,
    netPremium: number,
    tax: number,
    duePremium: number,

    optionPropertyName1?: string,
    optionPropertyName2?: string,
    optionPropertyName3?: string,

    optionPropertyText1?: string,
    optionPropertyText2?: string,
    optionPropertyText3?: string,

    optionValueList1? : string,
    optionValueList2? : string,
    optionValueList3? : string,

    options1: {value: string, name: string}[],
    options2: {value: string, name: string}[],
    options3: {value: string, name: string}[],

    optionValue1: string,
    optionValue2: string,
    optionValue3: string,

    
  }

  export const defaultBankPolicy: IBankPolicy = {
    policyID: 0,
    groupPolicyID: -1,
    contractNumber: '',
    contractNumberManual: '',
    contractNumberExternal: '',
    productCode: '',
    agencyCode: '',

    policyStatus: '00095',
    policyStatusDate: new Date(),

    effectiveDate: new Date(),
    loanDate: new Date(),
    expirationDate: new Date(),

    paymentFrequency: '00000',
    paymentDuration: 1,

    reimbursementStartDate: new Date(),
    reimbursementEndDate: new Date(),
    reimbursementDuration: 1,
    reimbursementDateAuto: true,

    riskElementID: 0,
    bankRiskElementID: 0,

    accountNumber: '',
    loanNumber: '',

    civility: '',
    maritalSituation: '',
    defaultLanguage: '',
    height: 0,
    weight: 0,

    adressLine1: '',
    adressLine2: '',
    adressLine3: '',

    
    firstName: '',
    lastName: '',
    personNameNIC: '',
    birthDate: new Date(),
    birthPlace: '',
    personIndice: '',
    
    portable1: '',
    portable2: '',
    email1: '',
    email2: '',
    professionalCategory: '',
    profession: '',

    isInsuredPayor: false,

    payorCivility: '',
    payorMaritalSituation: '',
    payorDefaultLanguage: '',

    payorHeight: 0,
    payorWeight: 0,

    payorAdressLine1: '',
    payorAdressLine2: '',
    payorAdressLine3: '',

    payorID: 0,
    bankPayorID: 0,
    payorFirstName: '',
    payorLastName: '',
    payorPersonNameNIC: '',
    payorBirthDate: new Date(),
    payorBirthPlace: '',
    
    payorPersonIndice: '',
    
    payorPortable1: '',
    payorPortable2: '',
    payorEmail1: '',
    payorEmail2: '',
    payorProfessionalCategory: '',
    payorProfession: '',

    tarifInfos: [],
    coverages: [],

    netPremium: 0,

    duration: 0,
    durationUnit: 'year',
  }

  export interface IBankPolicySearch {
    
    groupPolicyID: number,
    productCode: string,
    agencyCode: string,
    policyStatus: string,
    isPolicyTransmited: boolean,

        
    personNameNIC: string,
    payorPersonNameNIC: string,
    
    effectiveDateStart: Date,
    effectiveDateEnd: Date
  }